import jwtDecode from 'jwt-decode';

interface JwtPayload {
    email: string;
    sub: string;
}

export const trackAnalytics = (eventName: string, data?: Record<string, unknown>): void => {
    console.log('Tracking analytics', eventName, data);
    analytics.track(eventName, data);
};

export const identifyUser = (
    accessToken: string | undefined,
    data: Record<string, unknown> = {},
): void => {
    if (!accessToken) return;
    const jwtPayload = jwtDecode<JwtPayload>(accessToken);
    const { email, sub: userId } = jwtPayload;
    if (email) data.email = email;
    analytics.identify(userId, data);
};
